<template>
  <div class="jisao">
    <div class="swipeDiv">
      <div class="num">目前已有{{ this.$store.getters.properties['MEM_TOMB_COUNT'] }}人使用</div>
      <van-swipe :autoplay="3000" :height="170">
        <van-swipe-item v-for="(image, index) in images" :key="index">
          <img v-lazy="image" />
        </van-swipe-item>
      </van-swipe>
    </div>
    <div class="jsDiv" @click="yyjs">
      <img src="../../assets/yuyuejisao.png" />
    </div>
    <div class="jsDiv">
      <img src="../../assets/js.png" />
    </div>
    <jisao-search></jisao-search>

    <div class="jingguanDiv">
      <div class="jingguanTitle">
        墓区景观
      </div>
      <div class="jingguanImg" v-for="(item, index) in scene_list" :key="index">
        <img :src="item.scenePhoto" />
     
      </div>
      <!-- <div class="jingguanImg">
        <img src="../../assets/jsjg.jpg" />
      </div>
      <div class="jingguanImg">
        <img src="../../assets/jsjg1.jpg" />
      </div>
      <div class="jingguanImg">
        <img src="../../assets/jsjg2.jpg" />
      </div>
      <div class="jingguanImg">
        <img src="../../assets/jsjg3.jpg" />
      </div>
      <div class="jingguanImg">
        <img src="../../assets/jsjg4.jpg" />
      </div>
      <div class="jingguanImg">
        <img src="../../assets/jsjg5.jpg" />
      </div> -->
    </div>
    <copyright></copyright>
  </div>
</template>

<script>
import jisaoSearch from './Search'
import copyright from './Copyright'
export default {
  name: 'ndex',
  components: {
    jisaoSearch,
    copyright,
  },
  data() {
    return {
      scene_list: [],
      keyValue: '',
      images: [require('../../assets/banner1.png'), require('../../assets/banner2.jpg')],
    }
  },
  beforeRouteEnter(to, from, next) {
    if (from.path.indexOf('shop') > -1) {
      localStorage.setItem('reload', 'true')
    } else {
      localStorage.removeItem('reload')
    }
    next()
  },
  methods: {
    yyjs() {
      this.$router.push({ path: '/shop/yyjs' })
    },
    getMemTombCount() {
      return this.$store.getters.properties
    },
    querySceneAll() {
      var that = this
      this.$queryAll('MemScene', {sort:{orderNum:1}}, ['id', 'scenePhoto'], function(res) {
        that.$fill(that.scene_list, res['data'])
      })
    },
  },
  created() {
     if (localStorage.getItem('reload')) {
      location.reload()
    }
    this.querySceneAll()
    localStorage.removeItem('keyword')
  },
}
</script>

<style>
.jisao .swipeDiv {
  height: 170px;
}
.jisao .my-swipe .van-swipe-item {
  color: #fff;
  font-size: 20px;
  line-height: 150px;
  text-align: center;
  background-color: #39a9ed;
}
.jisao .swipeDiv img {
  width: 100%;
}
.jisao .num {
  background: #cccccc8f;
  border-radius: 5px;
  height: 30px;
  line-height: 30px;
  color: #fff;
  position: absolute;
  padding: 0 10px;
  top: 10px;
  right: 5px;
  z-index: 9;
}
.jisao .jsDiv {
  width: 98%;
  margin: 0.1rem auto 0;
}
.jisao .jsDiv img {
  width: 100%;
}
.jisao .btn {
  border-radius: 2500px;
  color: #fff;
  background-image: none;
  background-color: #73c7a0;
  position: relative;
  border: 0px;
  display: -webkit-inline-box;
  display: -webkit-inline-flex;
  display: inline-flex;
  -webkit-box-align: center;
  -webkit-align-items: center;
  align-items: center;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
  justify-content: center;
  box-sizing: border-box;
  padding: 0 15px;
  font-size: 14px;
  height: 35px;
  line-height: 35px;
  text-align: center;
  text-decoration: none;
  overflow: visible;
  margin-left: 5px;
  -webkit-transform: translate(0px, 0px);
  transform: translate(0px, 0px);
  margin-right: 0;
}
.jisao .van-search__content {
  background: unset;
}
.jisao .van-search {
  width: 80%;
}
.jisao .searchDiv {
  width: 95%;
  margin: 0 auto;
  display: flex;
  justify-content: center;
  align-items: center;
}
.jisao .jingguanDiv {
  width: 95%;
  margin: 0 auto;
}
.jisao .jingguanTitle {
  width: 100%;
  color: #73c7a0;
  border-bottom: 1px solid #73c7a0;
  line-height: 40px;
  height: 40px;
  text-align: center;
  margin-top: 10px;
}
.jisao .jingguanImg {
  padding-top: 10px;
  width: 95%;
  margin: 0 auto;
}
.jisao .jingguanImg img {
  width: 100%;
}
</style>
